/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { Button } from "@rewards-web/shared/components/button";
import { Typography } from "@rewards-web/shared/components/typography";
import { useFormatters } from "@rewards-web/shared/modules/formatter";
import { AppTheme } from "@rewards-web/shared/style/types";

import EnvelopeUrl from "../../../../images/email-icon.png";

export interface GiftCardRedeemDrawerRedeemSuccessProps {
  onClose: () => void;
  email: string;
}

export function GiftCardRedeemDrawerRedeemSuccess({
  onClose,
  email,
}: GiftCardRedeemDrawerRedeemSuccessProps) {
  const { formatMessage } = useFormatters();
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      `}
    >
      <img
        src={EnvelopeUrl}
        width={135}
        alt={formatMessage({
          description:
            "Redeem points drawer > redeem succes > envelope icon alt",
          defaultMessage: "Email icon",
        })}
        css={(theme: AppTheme) => css`margin-bottom: ${theme.spacing(2.5)})`}
      />
      <Typography variant="body">
        {formatMessage(
          {
            defaultMessage:
              "A link to claim your gift card has been sent to <bordered_email>{email}</bordered_email>Follow the email(s) for more details. Please check Spam and Junk folders!",
            description: "Redeem points drawer > redeem success > content",
          },
          {
            email,
            bordered_email: (node) => (
              <Typography
                variant="subtitle"
                css={(theme: AppTheme) => css`
                  width: 100%;
                  margin: ${theme.spacing(2.5, 0)};
                  padding: ${theme.spacing(2.5)};
                  text-align: center;
                  border-radius: 10px;
                  background-color: ${theme.palette.grey[200]};
                `}
              >
                <span
                  css={css`
                    overflow-wrap: break-word;
                  `}
                >
                  {node}
                </span>
              </Typography>
            ),
          }
        )}
      </Typography>
      <Button
        type="button"
        onClick={onClose}
        label={formatMessage({
          description:
            "Redeem points drawer > redeem success > close button label",
          defaultMessage: "Close",
        })}
        color="primary"
        width="full"
        size="large"
        css={(theme: AppTheme) =>
          css`
            margin-top: ${theme.spacing(3.75)};
          `
        }
      />
    </div>
  );
}
